 document.addEventListener('DOMContentLoaded', function () {
        const form = document.getElementById('signup-form');
        const submitBtn = document.getElementById('submit-btn');
        const btnText = submitBtn.querySelector('.btn-text');
        const btnLoading = submitBtn.querySelector('.btn-loading');
        const messagesContainer = document.getElementById('form-messages');

        // API Configuration - Replace with your actual endpoint
        const ROOT_ENDPOINT = 'https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com';

        const API_ENDPOINTS = {
          findCustomer: '/api/customers/find',
          createCustomer: '/api/customer/create',
          assignTag: '/api/customer/tags',
          sendInvite: '/api/invite',
        };

        // Slugify function for location name
        function slugify(text) {
          return text
            .toLowerCase()
            .replace(/&/g, ' and ')
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '');
        }

        // Show message function with proper color coding
        function showMessage(message, type = 'info', duration = 8000) {
          let bgColor, borderColor, textColor, icon;
          
          switch(type) {
            case 'success':
              bgColor = 'rgba(34, 197, 94, 0.15)';
              borderColor = '#22c55e';
              textColor = '#86efac';
              icon = '✅';
              break;
            case 'error':
              bgColor = 'rgba(239, 68, 68, 0.15)';
              borderColor = '#ef4444';
              textColor = '#fca5a5';
              icon = '❌';
              break;
            case 'warning':
              bgColor = 'rgba(245, 158, 11, 0.15)';
              borderColor = '#f59e0b';
              textColor = '#fcd34d';
              icon = '⚠️';
              break;
            case 'info':
            default:
              bgColor = 'rgba(59, 130, 246, 0.15)';
              borderColor = '#3b82f6';
              textColor = '#93c5fd';
              icon = 'ℹ️';
              break;
          }
          
          messagesContainer.innerHTML = `<div class="alert alert-${type}" style="padding: 1rem; border-radius: 0.5rem; background: ${bgColor}; border: 1px solid ${borderColor}; color: ${textColor}; display: flex; align-items: center; gap: 0.75rem;">
            <span style="font-size: 1.25rem;">${icon}</span>
            <span style="flex: 1;">${message}</span>
          </div>`;
          messagesContainer.style.display = 'block';

          setTimeout(() => {
            messagesContainer.style.display = 'none';
          }, duration);
        }

        // Set loading state
        function setLoadingState(loading) {
          if (loading) {
            btnText.style.display = 'none';
            btnLoading.style.display = 'inline';
            submitBtn.disabled = true;
            submitBtn.classList.add('opacity-70', 'cursor-not-allowed');
          } else {
            btnText.style.display = 'inline';
            btnLoading.style.display = 'none';
            submitBtn.disabled = false;
            submitBtn.classList.remove('opacity-70', 'cursor-not-allowed');
          }
        }

        // Australian mobile validation (without country code or 0)
        function validateAustralianMobileNew(number) {
          if (!number) return false;

          let digits = number.replace(/\D/g, '');

          if (digits.startsWith('61') || digits.startsWith('0')) {
            return false;
          }

          if (digits.length !== 9) {
            return false;
          }

          return /^4\d{8}$/.test(digits);
        }

        // Format phone number for API — always E.164 (+61, drop any leading 0/61)
        function formatPhone(phone) {
          let digits = phone.replace(/\D/g, '');
          if (digits.startsWith('61')) digits = digits.slice(2);
          if (digits.startsWith('0')) digits = digits.slice(1);
          return '+61' + digits;
        }

        // Extract customer ID from GID
        function extractCustomerId(gid) {
          const match = gid?.match(/\/(\d+)$/);
          return match ? match[1] : null;
        }

        // API call function
        async function apiCall(endpoint, data) {
          const res = await fetch(ROOT_ENDPOINT + endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          });

          const json = await res.json();
          return { ok: res.ok, data: json, status: res.status };
        }

        // Main submission handler - using location instead of club
        async function handleSubmit(fullName, email, phone, location) {
          showMessage('🔍 Checking your member status...', 'info', 5000);

          const find = await apiCall(API_ENDPOINTS.findCustomer, { email });

          if (find.ok && find.data.matchType === 'exact') {
            const id = extractCustomerId(find.data.customer.id);

            await apiCall(API_ENDPOINTS.assignTag, {
              customerId: id,
              newTag: `conditn,${location}`,
            });

            if (find.data.customer.state === 'DISABLED') {
              await apiCall(API_ENDPOINTS.sendInvite, { id });
              showMessage(`🎟️ Welcome back ${fullName.split(' ')[0]}! Your member link has been resent to ${email}. Check your inbox to claim your $9.95 meals.`, 'success', 7000);
            } else {
              showMessage(`✅ Member access confirmed! ${fullName.split(' ')[0]}, check your email for your $9.95 per meal link.`, 'success', 6000);
            }
            return;
          }

          showMessage('📝 Creating your member account...', 'info', 5000);

          const create = await apiCall(API_ENDPOINTS.createCustomer, {
            email,
            phone: formatPhone(phone),
            fullName,
            location,
          });

          if (create.ok) {
            const id = extractCustomerId(create.data.customer.id);
            await apiCall(API_ENDPOINTS.sendInvite, { id });

            showMessage(`🎉 Welcome to Thr1ve, ${fullName.split(' ')[0]}! Your member link has been sent to ${email}. Click it to build your first meal plan at $9.95 per meal.`, 'success', 8000);
          } else {
            showMessage(create.data.message || '⚠️ Something went wrong. Please try again or contact support.', 'error', 6000);
          }
        }

        // Form submission
        form.addEventListener('submit', async function (e) {
          e.preventDefault();

          const fullName = document.getElementById('fullName').value.trim();
          const email = document.getElementById('emailAddress').value.trim().toLowerCase();
          const phone = document.getElementById('mobileNumber').value;
          const locationRaw = document.getElementById('clubName').value;
          const location = slugify(locationRaw);
          const termsChecked = document.getElementById('termsCheckbox').checked;

          // Validate full name
          if (!fullName || fullName.length < 2) {
            showMessage('📝 Please enter your full name so we can personalize your meals.', 'error', 4000);
            document.getElementById('fullName').focus();
            return;
          }

          // Validate email
          if (!email || !email.includes('@')) {
            showMessage('📧 Please enter a valid email address to receive your member link.', 'error', 4000);
            document.getElementById('emailAddress').focus();
            return;
          }

          // Validate mobile
          if (!validateAustralianMobileNew(phone)) {
            showMessage('📱 Please enter a valid Australian mobile number (+61 4XX XXX XXX) for delivery updates.', 'error', 5000);
            document.getElementById('mobileNumber').focus();
            return;
          }

          // Validate location selection
          if (!locationRaw || locationRaw === '') {
            showMessage('📍 Please select your Conditn gym location to verify your membership.', 'error', 4000);
            document.getElementById('clubName').focus();
            return;
          }

          // Validate terms
          if (!termsChecked) {
            showMessage('✅ Please confirm you\'re a Conditn member and agree to our terms to access the $9.95 rate.', 'warning', 5000);
            return;
          }

          setLoadingState(true);

          try {
            await handleSubmit(fullName, email, phone, location);
            form.reset();

            setTimeout(() => {
              // window.location.href = '/pages/thank-you';
            }, 3000);
          } catch (err) {
            console.error('Submission error:', err);
            showMessage('⚠️ An error occurred. Please try again or contact support.', 'error', 5000);
          }

          setLoadingState(false);
        });

        // Phone number formatting (as user types)
        const phoneInput = document.getElementById('mobileNumber');

        if (phoneInput) {
          phoneInput.addEventListener('input', function (e) {
            let value = e.target.value;

            let digits = value.replace(/\D/g, '');

            if (digits.startsWith('61')) digits = digits.slice(2);
            if (digits.startsWith('0')) digits = digits.slice(1);

            if (digits.length === 1 && digits !== '4') {
              digits = '4';
            }

            digits = digits.slice(0, 9);

            let formatted = digits.replace(/(\d{3})(\d{3})(\d{0,3})/, (_, a, b, c) =>
              [a, b, c].filter(Boolean).join(' ')
            );

            e.target.value = formatted;
          });
        }

        // Smooth scroll for CTA buttons
        document.querySelectorAll(".btn-cta-custom, a[href='#signup']").forEach((button) => {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            const signupForm = document.querySelector('#signup');
            if (signupForm) {
              signupForm.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          });
        });
      });
